const article = {
	slug: "ai-that-does-the-work",
	title: "When AI Stops Answering Questions and Starts Doing the Work",
	date: "5 April 2026",
	updated: null,
	description: "Most engineering teams have an AI tool but haven't changed how they work. The shift comes when AI moves from answering questions to doing real workflow-level work.",
	keywords: ["AI engineering", "engineering leadership", "agentic AI", "developer workflows", "persistent context"],
	tldr: "Having an AI tool is not the same as changing how your team works. The real unlock is AI that reads files, runs commands, and does the work alongside engineers.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, April 2026.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	markdown: `Most engineering teams I talk to have an AI tool.

Almost none of them have changed how they work.

I got certified on agentic coding tools about 6 months ago. That taught me the model.

What it didn't prepare me for: what happens when the AI stops answering questions and starts doing the work.

I have spent 100+ hours across late nights and side projects learning what it actually unlocks for engineering teams.

## Three things it changes

Your team stops losing context every time someone joins or leaves.

Every project carries its own persistent memory. Decisions, conventions, known landmines. Loaded automatically. Onboarding a new engineer doesn't mean starting from zero.

Your engineers ship instead of copy-paste. The tool works inside the repo by reading files, running commands, writing code. Not generating text to paste somewhere. Actually doing the work alongside your team.

The longer you use it, the less you have to explain. It already knows the codebase. It's the difference between a consultant who reads the brief once and one who's been in every standup for three months.

None of that changes with a chat window.

## A concrete example

I ran it against an earlier version of one of my pet projects.

Four specialized agents in parallel, each covering a different attack surface. The results:

- 18 confirmed findings (3 Critical, 6 High, 9 Medium)
- A prioritized remediation plan
- 8 false positives filtered out with explanations

That's a security audit. Done overnight. On a side project.

If your team is still prompting and copy-pasting, there is a much better way to work.`,
};

export default article;
